/**
 * Which setup step a new manager should be nudged towards, derived from their apartment list.
 *
 * | Account state                                          | Step              |
 * |--------------------------------------------------------|-------------------|
 * | list not loaded, or the request failed                 | none (never guess)|
 * | no apartment                                           | ADD_APARTMENT     |
 * | apartments, none with a calendar source (iCal/Hostex)  | CONNECT_CALENDAR  |
 * | at least one apartment with a source (even a failing)  | none              |
 *
 * Derived on every read and never stored: a stored "dismissed" or "step 2 reached" flag would be
 * wrong after logout, on another device and after the manager deletes things. A failing sync
 * (`calendarSyncOk === false`) is a different problem from onboarding and does not bring the cue back.
 * See docs/ONBOARDING_NAV_CUE.md.
 */
export type SetupStep = 'ADD_APARTMENT' | 'CONNECT_CALENDAR';

export function deriveSetupStep(
  apartments: unknown,
): SetupStep | null {
  // A proxy misroute can answer 200 with an HTML string; only a real list may start onboarding.
  if (!Array.isArray(apartments)) return null;
  if (apartments.length === 0) return 'ADD_APARTMENT';
  return (apartments as Array<{ calendarSyncOk?: boolean | null } | null>).every((a) => a?.calendarSyncOk == null) ? 'CONNECT_CALENDAR' : null;
}

export const SETUP_STATE_CHANGED_EVENT = 'guestbook:setup-state-changed';

/** Call after something that can move the manager between steps (apartment or source added/removed). */
export function notifySetupStateChanged() {
  window.dispatchEvent(new Event(SETUP_STATE_CHANGED_EVENT));
}
